import { useNuxtApp } from '#app'
import type { Rating } from '~/types/types'

export const ratingsRepository = () => {
  const { $api } = useNuxtApp()

  return {
    async get(filters: Record<string, any> = {}, page: number = 1): Promise<{ data: Rating[]; nextPage: number | null }> {
      const response = await $api<{ data: Rating[]; meta: { current_page: number; last_page: number } }>('ratings', {
        method: 'GET',
        params: { ...filters, page },
      })

      const nextPage =
        response?.meta?.current_page && response?.meta?.current_page < response?.meta?.last_page
          ? response.meta.current_page + 1
          : null

      return {
        data: response.data,
        nextPage,
      }
    },
    async getHome(filters: Record<string, any> = {}, page: number = 1): Promise<{ data: Rating[]; nextPage: number | null }> {
      const locationCookie = useCookie<{ lat: number; lng: number }>('location', {
        default: () => ({ lat: 0, lng: 0 })
      });

      const visitedPlaceIds = useCookie<string[]>('visitedPlaceIds', { default: () => [] }).value || [];

      const visitedPlaceParams = visitedPlaceIds.reduce((acc, id, index) => {
        acc[`visitedPlaceIds[${index}]`] = id;
        return acc;
      }, {} as Record<string, string>);
      

      const response = await $api<{ data: Rating[]; meta: { current_page: number; last_page: number } }>('home', {
        method: 'GET',
        params: { ...filters, page,
          ...visitedPlaceParams, // Adds visitedPlaceIds[0], visitedPlaceIds[1], etc.
          latitude: locationCookie.value.lat ? locationCookie.value.lat : null,
          longitude: locationCookie.value.lng ? locationCookie.value.lng : null,
         },
      })

      const nextPage =
        response?.meta?.current_page && response?.meta?.current_page < response?.meta?.last_page
          ? response.meta.current_page + 1
          : null

      return {
        data: response.data,
        nextPage,
      }
    },
    async getMyRatings(filters: Record<string, any> = {}, page: number = 1): Promise<{ data: Rating[]; nextPage: number | null }> {
      const response = await $api<{ data: Rating[]; meta: { current_page: number; last_page: number } }>('my-ratings', {
        method: 'GET',
        params: { ...filters, page },
      })

      const nextPage =
        response?.meta?.current_page && response?.meta?.current_page < response?.meta?.last_page
          ? response.meta.current_page + 1
          : null

      return {
        data: response.data,
        nextPage,
      }
    },

    async store(placeId: string, formData: FormData): Promise<{ response: { status: boolean; message: string } }> {
      const response = await $api<{ status: boolean; message: string }>(`places/${placeId}/ratings`, {
        method: 'POST',
        body: formData,
        
      })


      return {
        response,
      }
    },

    async edit(rateId: string, formData: FormData): Promise<{ response: { status: boolean; message: string } }> {
      const response = await $api<{ status: boolean; message: string }>(`ratings/${rateId}/update`, {
        method: 'POST',
        body: formData,
      })

      return {
        response,
      }
    },
    async delete(rateId: string): Promise<{ response: { status: boolean; message: string } }> {
      const response = await $api<{ status: boolean; message: string }>(`ratings/${rateId}`, {
        method: 'DELETE',
      })

      return {
        response,
      }
    },
    async toggleLikes(rateId: string): Promise<{ response: { status: boolean; message: string } }> {
      const response = await $api<{ status: boolean; message: string }>(`ratings/${rateId}/toggle-likes`, {
        method: 'POST',
      })
      return {
        response,
      }
    },
  }
}
